import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Reports from './pages/Reports';
import Requests from './pages/Requests';
import Support from './pages/Support';

export default function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-4xl mx-auto p-6">
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </main>
    </div>
  );
}
